import { Injectable } from "@angular/core";
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { AppConfigService } from "./app-config.service";

@Injectable({
    providedIn: 'root'
})
export class AppInsightsService {
    logPageView(name?: string, url?: string) {
        if (AppConfigService.settings?.logging?.appInsights) {
            AppConfigService.appMonitor.trackPageView({
                name: name,
                uri: url
            });
        }
    }

    // Log non-exception type errors, e.g. invalid API request
    logError(error: any, severityLevel?: SeverityLevel) {
        if (AppConfigService.settings?.logging?.console) {
            this.sendToConsole(error, severityLevel);
        }
    }

    logEvent(name: string, properties?: { [key: string]: any }) {
        if (AppConfigService.settings?.logging?.appInsights) {
            AppConfigService.appMonitor.trackEvent({ name: name }, properties);
        }
    }

    logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        if (AppConfigService.settings?.logging?.appInsights) {
            AppConfigService.appMonitor.trackMetric({ name: name, average: average }, properties);
        }
    }

    logException(exception: Error, severityLevel?: SeverityLevel) {
        if (AppConfigService.settings?.logging?.console) {
            this.sendToConsole(exception, severityLevel);
        }
        if (AppConfigService.settings?.logging?.appInsights) {
            AppConfigService.appMonitor.trackException({ exception: exception, severityLevel: severityLevel });
        }
    }

    logTrace(message: string, properties?: { [key: string]: any }, severityLevel?: SeverityLevel) {
        if (AppConfigService.settings?.logging?.appInsights) {
            AppConfigService.appMonitor.trackTrace({ message: message }, properties, severityLevel);
        }
    }

    private sendToConsole(error: any, severityLevel: SeverityLevel = SeverityLevel.Error) {

        switch (severityLevel) {
            case SeverityLevel.Critical:
            case SeverityLevel.Error:
                (<any>console).group('Application Error:');
                console.error(error);
                if (error.message) {
                    console.error(error.message);
                }
                if (error.stack) {
                    console.error(error.stack);
                }
                (<any>console).groupEnd();
                break;
            case SeverityLevel.Warning:
                (<any>console).group('Application Warning:');
                console.warn(error);
                (<any>console).groupEnd();
                break;
            case SeverityLevel.Information:
                (<any>console).group('Application Information:');
                console.log(error);
                (<any>console).groupEnd();
                break;
        }
    }
}
